//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocRow from './sub/FamilyDetailRow.vue';
export default {
    name: "FamilyDetailsTable",
    props: {
        form: {
            type: Object,
            required: true
        },
        doc: {
            type: Object,
            required: true
        },
        is_new: {
            type: Boolean,
            required: true
        },
        allow_edit: {
            type: Boolean,
            required: true
        },
        set_value: {
            type: Function,
            required: true
        },
    },
    data() {
        const { doc } = this;

        if (!doc.family_details) {
            doc.family_details = new Array();
        }

        const data = {
            rows: this.doc.family_details,
        };

        return data;
    },
    components: {
        DocRow,
    },
    methods: {
        add_row() {
            const { rows } = this;
            const new_row = {
                first_name: "",
                last_name: "",
                full_name: "",
                relationship: "",
                birth_date: "",
                cell_phone: "",
                tel_phone: "",
                email: "",
                comments: "",
            };
            rows.push(new_row);
        },
        delete_row(index) {
            const { rows } = this;
            const start = index - 1;
            const delete_count = 1;
            rows.splice(start, delete_count);
        },
    }
}
